import { render, staticRenderFns } from "./OpenQuestionnaireFormItemChoice.vue?vue&type=template&id=0661a192&scoped=true&"
import script from "./OpenQuestionnaireFormItemChoice.vue?vue&type=script&lang=js&"
export * from "./OpenQuestionnaireFormItemChoice.vue?vue&type=script&lang=js&"
import style0 from "./OpenQuestionnaireFormItemChoice.vue?vue&type=style&index=0&id=0661a192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0661a192",
  null
  
)

export default component.exports